import THEME from 'pobble-components/dist/theme'

const { FONT_SIZES, COLORS } = THEME

export default {
  message: {
    margin: '0',
    color: COLORS.TEXT.LIGHT_GREY.NORMAL,
    padding: '20px',
    ...FONT_SIZES.HEADING_DEFAULT.STYLE
  }
}
